var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex external-links terms"},[_c('a',{attrs:{"href":"https://hmc.co.il/mymedical-doctors-%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA-%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA/","target":"_blank"}},[_vm._v(" מדיניות פרטיות ")]),_c('a',{attrs:{"href":"https://hmc.co.il/mymedicaldoctor-terms/","target":"_blank"}},[_vm._v(" תנאי השימוש ")])])
}]

export { render, staticRenderFns }